import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import MILogo from "../../images/MI-Image.png";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import Loading from "../../utlis/Loading";

// Socket initialization
const socket = io(`${process.env.REACT_APP_API_WS_URL}`, {
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  transports: ["websocket"],  // ⭐ Force WebSocket only
  upgrade: false,              // ⭐ Disable polling upgrade
});

const OkDollar = () => {
  const { paymentMethod } = useParams();
  const [searchParams] = useSearchParams();
  const paymentToken = searchParams.get("paymentToken");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  const [phoneNo, setPhoneNo] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (paymentToken) {
      // Register payment token with the server
      socket.emit("registerPaymentToken", paymentToken);
    }

    // Listen for Status updates from the server
    socket.on("paymentStatusUpdate", (data) => {
      if (data.paymentToken === paymentToken) {
        setStatus({
          code: data.statusCode,
          description: data.statusDescription,
        });

        navigate("/successPage", {
          state: {
            amount: data.amount,
            invoiceNumber: data.invoiceNo,
            currencyCode: data.currencyCode,
            serviceCharges: data.serviceCharges,
          },
        });
      }
    });

    // Handle reconnection events
    socket.on("connect", () => {
      if (paymentToken) {
        socket.emit("registerPaymentToken", paymentToken);
      }
    });

    return () => {
      if (paymentToken) {
        socket.off("paymentQRUpdate");
      }
      socket.off("connect");
    };
  }, [paymentToken, paymentMethod]);

  useEffect(() => {}, [paymentToken, navigate]);

  // Fetch transaction data from the backend
  const sendTransaction = async () => {
    if (!paymentToken) {
      console.error("Payment token is missing!");
      setMessage("Payment token is missing!");
      setLoading(false);
      return;
    }

    if (!phoneNo.trim()) {
      setMessage("Phone number is required!");
      return;
    }

    setLoading(true);
    setMessage("");

    console.log("Phone", phoneNo);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/okdollar/paymentGateWay`,
        null,
        { params: { token: paymentToken, phoneNo } }
      );

      console.log("Transaction successful:", response.data);
      if (response.data.destination != null) {
        setLoading(false);

        console.log(
          response.data.encryptedPayload,
          "IV ",
          response.data.ivKey,
          "Merchant NUmber",
          response.data.destination
        );
        handleRedirect(
          response.data.encryptedPayload,
          response.data.ivKey,
          response.data.destination
        );
        // setMessage(
        //   `Transaction successful! Reference Number: ${response.data.refNumber}`
        // );
      } else {
        setLoading(true);
        console.warn("No reference number received from the API.");
        setMessage("Transaction failed: No reference number received.");
      }
    } catch (error) {
      console.error(
        "Error fetching transaction data:",
        error.response?.data || error.message
      );
      setMessage("Error processing transaction. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRedirect = (encryptedData, iv, merchantNumber) => {
    // Create the final value for the hidden input
    const requestToJson = `${encryptedData},${iv},${merchantNumber}`;

    // Create a form element dynamically
    const htmlForm = document.createElement("form");
    htmlForm.id = "myform";
    htmlForm.method = "POST";
    htmlForm.action = "https://uatokpaymentgateway.okdollar.org/";
    // htmlForm.action = "https://okpaygateway.okdollar.org/";
    htmlForm.style.display = "none"; // Optional: Hide the form from the DOM

    // Create a hidden input element to hold the data
    const htmlInput = document.createElement("input");
    htmlInput.type = "hidden";
    htmlInput.name = "requestToJson";
    htmlInput.value = requestToJson;

    // Append the input to the form
    htmlForm.appendChild(htmlInput);

    // Append the form to the document body
    document.body.appendChild(htmlForm);

    htmlForm.submit();

    // // Delay submission by 10 seconds
    // setTimeout(() => {
    //     console.log("Submitting the form...");
    //     htmlForm.submit();
    // }, 10000); // 10 seconds delay
  };

  return loading ? (
    <Loading />
  ) : (
    <div className="container mt-5">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <img
            src={MILogo}
            alt="Logo"
            className="me-2"
            style={{ objectFit: "cover" }}
          />
        </div>
      </div>

      {/* Payment Section */}
      <div className="mt-3">
        <h5 className="text-primary m-0">Pay for Myanma Insurance</h5>
      </div>

      <div className="container mt-4">
        <h5>OK$ PAYMENT</h5>
        <div
          className="d-flex flex-column flex-md-row justify-content-center align-items-center text-center"
          style={{ minHeight: "50vh", padding: "1rem" }}
        >
          <div className="w-100 w-md-auto mb-3 mb-md-0">
            <label htmlFor="phoneNo">Phone Number</label>
          </div>

          <div className="w-100 w-md-auto mb-3 mb-md-0">
            <input
              type="text"
              id="phoneNo"
              className="form-control"
              value={phoneNo}
              onChange={(e) => setPhoneNo(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="d-flex flex-column flex-md-row w-100 w-md-auto">
            <button
              className="btn btn-secondary mx-0 mx-md-2 my-2 my-md-0"
              onClick={() => {
                setPhoneNo("");
                setMessage("");
              }}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary mx-0 mx-md-2"
              onClick={sendTransaction}
              disabled={loading || !phoneNo.trim()}
            >
              {loading ? "Processing..." : "Continue Payment"}
            </button>
          </div>

          {message && <div className="mt-3 w-100">{message}</div>}
        </div>
      </div>
    </div>
  );
};

export default OkDollar;
